export default () => {
  if( window.location.host.indexOf( 'localhost' ) !== -1 ) {
    return 'https://ark-api-staging.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management-staging2.proof-point-suite.com' ) !== -1 ) {
    return 'https://ark-api-staging.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management-staging3.proof-point-suite.com' ) !== -1 ) {
    return 'https://ark-api-staging3.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management-staging4.proof-point-suite.com' ) !== -1 ) {
    return 'https://ark-api-staging4.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management-staging5.proof-point-suite.com' ) !== -1 ) {
    return 'https://ark-api-staging5.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management-staging.proof-point-suite.com' ) !== -1 ) {
    return 'https://ark-api-staging.proof-point-suite.com';
  } else if( window.location.host.indexOf( 'ark-management.aciso-suite.com' ) !== -1 ) {
    return 'https://ark-api.aciso-suite.com';
  } else if( window.location.host.indexOf( 'ark-management.tennis-suite.com' ) !== -1 ) {
    return 'https://ark-api.tennis-suite.com';
  }
}
